<template>
    <div>
        <Row type="none" class="bg-white rounded shadow">
            <Modal
                :text="modalText"
                id="modal_show1"
            />

            <Modal
                :text="modalText"
                id="modal_router"
                :on-ok-pressed="goNext"
                :is-ok-only="false"
                ok-text="yes"
                cancel-text="no"
            />

            <div class="grid grid-cols-12 gap-3 container py-4">
                <div class="col-span-6 relative">
                    <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute bottom-9 ml-10">
                        {{ $t('product.name') }}
                    </div>

                    <img src="/images/search-interface-symbol.png" alt="" class="h-6 absolute left-2 top-2">
                    <b-form-input
                        class="border-gray-300 pl-10 w-full h-11 focus:ring-0"
                        @input="onBarcodeScanned"
                        v-model="search.productName"
                    />
                </div>

                <div class="col-span-6 position-relative">
                    <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute bottom-9 ml-2">
                        {{ $t('warehouse.title') }}
                    </div>
                    <b-form-select @change="fetchPIW" v-model="search.warehouseId" class="border-gray-300 h-11 focus:ring-0">
                        <b-form-select-option :value="null">{{ $t('filter.all') }}</b-form-select-option>
                        <b-form-select-option v-for="item in warehouses" :key="item.id" :value="item.id">
                            {{ item.name }}
                        </b-form-select-option>
                    </b-form-select>
                </div>
            </div>

            <div v-if="modelForm.inventoryItems.length > 0" class="text-xl text-main font-bold pt-3 container">
                {{ $t('inventory.result') }}
            </div>

            <div v-if="modelForm.inventoryItems.length > 0" class="grid grid-cols-12 gap-3 mt-4 container">
                <div class="border border-gray-700 rounded h-11 col-span-12 md:col-span-6 position-relative">
                    <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-3 ml-2">
                        {{ $t('inventory.allProducts') }}
                    </div>
                    <div class="pt-2 pl-3 font-bold text-gray-500">
                        {{ modelForm.inventoryItems.length }}
                    </div>
                </div>

                <div class="border border-gray-700 rounded h-11 col-span-12 md:col-span-6 position-relative">
                    <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-3 ml-2">
                        {{ $t('inventory.nonFitProducts') }}
                    </div>
                    <div class="pt-2 pl-3 font-bold text-gray-500">
                        {{ modelForm.differentProductCount }}
                    </div>
                </div>

                <div class="border border-gray-700 rounded h-11 col-span-12 md:col-span-4 position-relative">
                    <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-3 ml-2">
                        {{ $t('inventory.fitProducts') }}
                    </div>
                    <div class="pt-2 pl-3 font-bold text-gray-500">
                        {{ modelForm.inventoryItems.length - modelForm.differentProductCount }}
                    </div>
                </div>

                <div class="border border-gray-700 rounded h-11 col-span-12 md:col-span-4 position-relative">
                    <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-3 ml-2">
                        {{ $t('inventory.profitProducts') }}
                    </div>
                    <div class="pt-2 pl-3 font-bold text-gray-500">
                        {{ modelForm.profitCount }}
                    </div>
                </div>

                <div class="border border-gray-700 rounded h-11 col-span-12 md:col-span-4 position-relative">
                    <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-3 ml-2">
                        {{ $t('inventory.deficitProducts') }}
                    </div>
                    <div class="pt-2 pl-3 font-bold text-gray-500">
                        {{ modelForm.deficitCount }}
                    </div>
                </div>
            </div>

            <div v-if="modelForm.inventoryItems.length > 0" class="text-xl text-main font-bold pt-3 container">
                {{ $t('inventory.finance') }}
            </div>

            <div v-if="modelForm.inventoryItems.length > 0" class="grid grid-cols-12 gap-3 mt-4 pb-4 container">
                <div class="border border-gray-700 rounded h-11 col-span-12 position-relative">
                    <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 absolute -top-3">
                        {{ $t('inventory.sumSelectedProducts') }}
                    </div>
                    <div class="pt-2 pl-3 flex justify-center">
                        <div class="text-gray-500 font-bold px-5">
                            {{ showCurrencyById(baseCurrencyId, modelForm.totalSumBefore) }}
                        </div>
                        <div>
                            <img src="/images/right-arrow%20-blue.png" alt="" class="h-4">
                        </div>
                        <div v-if="!isNaN(modelForm.totalSumAfter)" class="text-main font-bold px-5">
                            {{ showCurrencyById(baseCurrencyId, modelForm.totalSumAfter) }}
                        </div>
                        <div v-if="!isNaN(modelForm.totalSumAfter)" >
                            <img src="/images/right-arrow%20-blue.png" alt="" class="h-4">
                        </div>
                        <div v-if="!isNaN(modelForm.totalSumAfter)" class="text-red-500 font-bold px-5">
                            {{ showCurrencyById(baseCurrencyId, Math.abs(modelForm.totalSumBefore - modelForm.totalSumAfter)) }}
                        </div>
                    </div>
                </div>

                <div class="border border-gray-700 rounded h-11 col-span-12 md:col-span-6 position-relative">
                    <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-3 ml-2">
                        {{ $t('inventory.sumFitProducts') }}
                    </div>
                    <div v-if="!isNaN(modelForm.totalSumAfter)" class="pt-2 pl-3 font-bold text-gray-500">
                        {{
                            modelForm.totalSumAfter - (modelForm.profitSum + modelForm.deficitSum) > 0 ?
                                showCurrencyById(
                                    baseCurrencyId,
                                    modelForm.totalSumAfter - (modelForm.profitSum + modelForm.deficitSum)
                                ) : 0
                        }}
                    </div>
                </div>

                <div class="border border-gray-700 rounded h-11 col-span-12 md:col-span-6 position-relative">
                    <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-3 ml-2">
                        {{ $t('inventory.sumDifferenceProducts') }}
                    </div>
                    <div class="pt-2 pl-3 text-main font-bold">
                        {{ showCurrencyById(baseCurrencyId, modelForm.profitSum + modelForm.deficitSum) }}
                    </div>
                </div>

                <div class="border border-gray-700 rounded h-11 col-span-12 md:col-span-6 position-relative">
                    <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-3 ml-2">
                        {{ $t('inventory.sumProfitProducts') }}
                    </div>
                    <div class="pt-2 pl-3 text-green-500 font-bold">
                        {{ showCurrencyById(baseCurrencyId, modelForm.profitSum) }}
                    </div>
                </div>

                <div class="border border-gray-700 rounded h-11 col-span-12 md:col-span-6 position-relative">
                    <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-3 ml-2">
                        {{ $t('inventory.sumDeficitProducts') }}
                    </div>
                    <div class="pt-2 pl-3 text-red-500 font-bold">
                        {{ showCurrencyById(baseCurrencyId, modelForm.deficitSum) }}
                    </div>
                </div>
            </div>

        </Row>

        <Row type="none" class="bg-white rounded shadow">

            <div class="grid grid-cols-6 gap-3 mt-4">
                <div class="col-span-6 md:col-span-2 pl-3"  style="max-height: 700px; overflow-y: scroll">
                    <div
                        v-for="piw of this.filteredPiws"
                        :key="piw.id"
                        style="height: 50px; border-bottom: 1px solid #c5c5c5; cursor: pointer;"
                        :class="{'bg-info text-white' : bgColor(piw)}"
                        @click="select(piw)"
                        class="px-2 font-weight-bold overflow-hidden d-flex align-items-center justify-content-between"
                    >
                        <div style="max-width: 75%">
                            {{ piw.product.name.slice(0, 50) }}
                            <template v-if="piw.product.name.length > 50">...</template>
                        </div>
                        <div>{{ piw.amount }} {{ showUnitOfMeasure(piw.product.unitOfMeasure) }}</div>
                    </div>
                </div>

                <div v-if="modelForm.inventoryItems.length" class="col-span-6 md:col-span-4 -mr-1.5" style="max-height: 700px; overflow-y: scroll">
                    <InventoryMakeListTable :piw-list="modelForm.inventoryItems" @deleteOneRow="deleteOne" @changeResidue="changeResidue"/>
                </div>
            </div>

            <div class="container grid grid-cols-12 py-4">
                <div class="col-span-12 md:col-start-11 md:col-span-2">
                    <SubmitRow
                        sm-size="12"
                        md-size="12"
                        text="save"
                        :is-loading="isLoading"
                        :do-action="save"
                        :is-disabled="checkForValid() || modelForm.inventoryItems.length === 0"
                    />
                </div>
            </div>
        </Row>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import currencyFormatMixin from "@/mixin/currencyFormatMixin";
import InventoryMakeListTable from "@/components/InventoryMakeListTable.vue";
import SubmitRow from "@/components/SubmitRow.vue";
import Modal from "@/components/html/Modal.vue";
import currencyRateMixin from "@/mixin/currencyRateMixin";
import Row from "@/components/html/Row.vue";

export default {
    name: "InventoryMake",
    components: {Row, Modal, SubmitRow, InventoryMakeListTable},
    mixins: [currencyFormatMixin, currencyRateMixin],
    data() {
        return {
            breadcrumbItems: [
                {name: 'home', url: ''},
                {name: 'warehouse.title', url: 'warehouses'},
                {name: 'inventory.title'},
            ],
            modalText: '',
            isLoading: false,
            next: null,
            search: {
                productName: '',
                warehouseId: null
            },
            modelForm: {
                deficitCount: 0,
                profitCount: 0,
                totalSumBefore: 0,
                totalSumAfter: 0,
                differenceSum: 0,
                accurateProductSum: 0,
                differentProductSum: 0,
                differentProductCount: 0,
                deficitSum: 0,
                profitSum: 0,
                inventoryItems: []
            },
            piws: null,
            warehouses: null
        }
    },
    computed: {
        ...mapGetters(['getProductsInWarehouses', 'getWarehouses']),
        filteredPiws() {
            if (this.search.productName !== '') {
                return this.piws.filter((item) => {
                    return this.search.productName.toLowerCase().split(' ').every(v => item.product.name.toLowerCase().includes(v))
                })
            } else {
                return this.piws
            }
        },
    },
    methods: {
        ...mapActions([
            'fetchAllProductsInWarehouses',
            'searchProductInWarehouse',
            'fetchWarehousesSearch',
            'pushInventory',
            'setBreadcrumbItems'
        ]),
        onBarcodeScanned(barcode) {
            if (this.isNumber(barcode)) {
                this.piws.find((piw) => {
                    if (piw.product.barCode === barcode) {
                        this.select(piw)
                    }
                })
            }
        },
        isNumber(n) {
            return /^-?[\d.]+(?:e-?\d+)?$/.test(n)
        },
        goNext() {
            this.next()
        },
        fetchPIW() {
            this.$root.showOverlay = true

            if (this.search.warehouseId === null) {
                this.$store.state.productsInWarehouses.productsInWarehouses.isNeedFetch = true

                this
                    .fetchAllProductsInWarehouses()
                    .then(() => {
                        this.piws = this.getProductsInWarehouses
                        this.$root.showOverlay = false
                    })
                    .catch((reason) => {
                        this.$root.showOverlay = false
                        this.modalText = reason
                        this.$bvModal.show('modal_show1')
                    })
            } else {
                this
                    .searchProductInWarehouse(this.search)
                    .then(() => {
                        this.piws = this.getProductsInWarehouses
                        this.$root.showOverlay = false
                    })
                    .catch((reason) => {
                        this.$root.showOverlay = false
                        this.modalText = reason
                        this.$bvModal.show('modal_show1')
                    })
            }
        },
        select(piw) {
            if (this.modelForm.inventoryItems.find((item) => item.id === piw.id)) {
                let index = this.modelForm.inventoryItems.findIndex((item) => item.id === piw.id)
                this.modelForm.inventoryItems.splice(index, 1)
                piw.isSelected = false
            } else {
                this.modelForm.inventoryItems.push(piw)
                piw.isSelected = true
            }
        },
        bgColor(piw) {
            return !(piw.isSelected === undefined || piw.isSelected === false);
        },
        deleteOne(index) {
            this.modelForm.inventoryItems[index].isSelected = false
            this.modelForm.inventoryItems.splice(index, 1)
        },
        calc() {
            this.setToInitialState()

            this.modelForm.inventoryItems.forEach((piw) => {
                this.calcTotalSumBefore(piw)
                this.calcTotalSumAfter(piw)
                this.calcTotalDifferences(piw)
                this.calcDeficit(piw)
                this.calcProfit(piw)
            })
        },
        calcTotalSumBefore(piw) {
            this.modelForm.totalSumBefore += piw.amount * this.calculateAmountByBaseCurrency(
                piw.product.sellingPrice, piw.product.sellingPriceCurrency.shortName, this.baseCurrencyShortName
            )
        },
        calcTotalSumAfter(piw) {
            this.modelForm.totalSumAfter += piw.realAmount * this.calculateAmountByBaseCurrency(
                piw.product.sellingPrice, piw.product.sellingPriceCurrency.shortName, this.baseCurrencyShortName
            )
        },
        calcTotalDifferences(piw) {
            if (piw.amount !== parseInt(piw.realAmount)) {
                this.modelForm.differentProductCount++
                this.modelForm.differentProductSum += piw.product.realAmount * this.calculateAmountByBaseCurrency(
                    piw.product.sellingPrice, piw.product.sellingPriceCurrency.shortName, this.baseCurrencyShortName
                )
            }
        },
        calcDeficit(piw) {
            if (piw.amount > piw.realAmount) {
                this.modelForm.deficitCount++
                this.modelForm.deficitSum += ((piw.amount - piw.realAmount) * this.calculateAmountByBaseCurrency(
                        piw.product.sellingPrice, piw.product.sellingPriceCurrency.shortName, this.baseCurrencyShortName)
                )
            }
        },
        calcProfit(piw) {
            if (piw.amount < piw.realAmount) {
                this.modelForm.profitCount++
                this.modelForm.profitSum += ((piw.realAmount - piw.amount) * this.calculateAmountByBaseCurrency(
                        piw.product.sellingPrice, piw.product.sellingPriceCurrency.shortName, this.baseCurrencyShortName)
                )
            }
        },
        setToInitialState() {
            this.modelForm.deficitCount = 0
            this.modelForm.profitCount = 0
            this.modelForm.totalSumBefore = 0
            this.modelForm.totalSumAfter = 0
            this.modelForm.differenceSum = 0
            this.modelForm.accurateProductSum = 0
            this.modelForm.differentProductSum = 0
            this.modelForm.differentProductCount = 0
            this.modelForm.deficitSum = 0
            this.modelForm.profitSum = 0
        },
        changeResidue() {
            this.calc()
        },
        checkForValid() {
            return this.modelForm.inventoryItems.some((item) => {
                return item.realAmount === undefined || item.realAmount === "" || item.realAmount < 0
            })
        },
        save() {
            this.$root.showOverlay = true

            let data = {}
            data.difference = (this.modelForm.profitSum + this.modelForm.deficitSum).toString()
            data.productAmount = this.modelForm.inventoryItems.length
            data.deficit = this.modelForm.deficitCount
            data.profit = this.modelForm.profitCount
            data.inventoryItemDtos = this.modelForm.inventoryItems
            this.setProduct()

            this
                .pushInventory(data)
                .then(() => {
                    data.inventoryItemDtos.forEach((piw) => {
                        delete piw.isSelected
                    })

                    this.$i18nHelper.toUrl('inventory')
                    this.$root.showOverlay = false
                })
                .catch((reason) => {
                    this.$root.showOverlay = false
                    this.modalText = reason
                    this.$bvModal.show('modal_show1')
                })
        },
        setProduct() {
            this.modelForm.inventoryItems.forEach((piw) => {
                piw.differenceSum = (Math.abs(piw.amount - piw.realAmount) * parseFloat(piw.product.sellingPrice)).toString()
                piw.difference = (Math.abs(piw.amount - piw.realAmount)).toString()
                piw.product = piw.product['@id']
                piw.amount = piw.amount.toString()
                piw.realAmount = piw.realAmount.toString()
            })
        }
    },
    beforeRouteLeave (to, from , next) {
        if (this.modelForm.inventoryItems.length > 0 && to.name !== 'inventories') {
            this.modalText = this.$t('beforeLeaveAdvice')
            this.$bvModal.show('modal_router')
            this.next = next
        } else {
            next()
        }
    },
    watch: {
        'modelForm.inventoryItems'() {
            if (this.modelForm.inventoryItems.length === 0) {
                this.modelForm.inventoryItems.forEach((piw) => {
                    piw.isSelected = false
                })
            }

            this.calc()
        }
    },
    created() {
        this.$barcodeScanner.init(this.onBarcodeScanned)
        this.setBreadcrumbItems(this.breadcrumbItems)
    },
    destroyed() {
        this.$barcodeScanner.destroy()
    },
    mounted() {
        this.$root.showOverlay = true

        window.focus()

        this.$store.state.productsInWarehouses.productsInWarehouses.isNeedFetch = true
        this
            .fetchAllProductsInWarehouses()
            .then(() => {
                this.fetchWarehousesSearch(null)
                    .then(() => {
                        this.piws = this.getProductsInWarehouses
                        this.warehouses = this.getWarehouses
                        this.$root.showOverlay = false
                    })
                    .catch((reason) => {
                        this.$root.showOverlay = false
                        this.modalText = reason
                        this.$bvModal.show('modal_show1')
                    })
            })
            .catch((reason) => {
                this.$root.showOverlay = false
                this.modalText = reason
                this.$bvModal.show('modal_show1')
            })
    }
}
</script>

<style scoped>
.subtitle {
    color: #7E7E7E;
}

.digit {
    color: #444444;
    font-weight: 600;
}

::-webkit-scrollbar {
    width: 2px;
}

::-webkit-scrollbar-thumb {
    -webkit-border-radius: 10px;
    border-radius: 10px;
    background: #6539B2;
}
</style>
